export default __webpack_public_path__ + "static/Our-Impact-993d687f5e19f3c62503360e353bc1fc.webp";